module.exports = __webpack_public_path__ + "static/media/DMA.a6b1523e.png";